export interface PhoneCountryConfig {
  dialCode: string;
  digitLength: number;
  pattern: RegExp;
  errorMessage: string;
}

export const PHONE_COUNTRY_CONFIG: Record<string, PhoneCountryConfig> = {
  India: {
    dialCode: "+91",
    digitLength: 10,
    pattern: /^[6-9]\d{9}$/,
    errorMessage: "Enter valid 10-digit mobile number",
  },
};

export const DEFAULT_PHONE_CONFIG: PhoneCountryConfig =
  PHONE_COUNTRY_CONFIG.India;

export const getPhoneConfig = (
  countryName?: string | null
): PhoneCountryConfig => {
  if (!countryName) return DEFAULT_PHONE_CONFIG;
  return PHONE_COUNTRY_CONFIG[countryName] ?? DEFAULT_PHONE_CONFIG;
};
